export type ExistingLeadSummary = {
  _id: string;
  fullName: string;
  email?: string;
  phoneNumber: string;
};

export function getDuplicateLeadFromError(err: unknown): ExistingLeadSummary | null {
  const errors = (err as { error?: { errors?: unknown } })?.error?.errors;
  if (!errors || typeof errors !== 'object') return null;

  const record = errors as Record<string, unknown>;
  if (record['code'] !== 'DUPLICATE_LEAD') return null;

  const existing = record['existingLead'];
  if (!existing || typeof existing !== 'object') return null;

  const lead = existing as Record<string, unknown>;
  const _id = typeof lead['_id'] === 'string' ? lead['_id'] : '';
  const fullName = typeof lead['fullName'] === 'string' ? lead['fullName'] : '';
  const phoneNumber = typeof lead['phoneNumber'] === 'string' ? lead['phoneNumber'] : '';
  if (!_id || !fullName || !phoneNumber) return null;

  return {
    _id,
    fullName,
    email: typeof lead['email'] === 'string' ? lead['email'] : undefined,
    phoneNumber,
  };
}

export function duplicateLeadConfirmMessage(existing: ExistingLeadSummary): string {
  const contact = [existing.email, existing.phoneNumber].filter(Boolean).join(' · ');
  const leadLabel = contact ? `${existing.fullName} (${contact})` : existing.fullName;
  return `A lead already exists with the same email or phone number: ${leadLabel}. Create another lead anyway?`;
}
